import React, { createContext, useContext, useState, useCallback } from "react";
import RewardedAdModal from "@/components/RewardedAdModal";

const PaywallCtx = createContext(null);

/**
 * Ad-gate context — global rewarded-ad modal that any page can trigger via
 * `usePaywall().show(feature, onRewarded)`. Replaces the old payment-based
 * activation flow. Kept the same context name + hook signature so existing
 * `usePaywallGuard()` callers keep working.
 */
export function PaywallProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [feature, setFeature] = useState("this feature");
  const [callback, setCallback] = useState(null);

  const show = useCallback((featureName = "this feature", onRewarded) => {
    setFeature(featureName);
    setCallback(() => onRewarded);
    setOpen(true);
  }, []);

  return (
    <PaywallCtx.Provider value={{ show }}>
      {children}
      <RewardedAdModal
        open={open}
        onClose={() => setOpen(false)}
        kind="generic"
        title="Unlock more readings"
        description={`Watch a short ad to unlock 3 more premium features including ${feature}.`}
        onRewarded={(result) => { if (callback) callback(result); }}
      />
    </PaywallCtx.Provider>
  );
}

export function usePaywall() {
  return useContext(PaywallCtx);
}

/** Recognises the 402 shapes that the ad-gate backend returns. */
export function isActivationRequired(err) {
  const data = err?.response?.data?.detail;
  return err?.response?.status === 402 && (
    data?.error === "ad_required" ||
    data?.error === "activation_required" ||
    typeof data === "string"
  );
}

export function isChatQuotaExceeded(err) {
  const data = err?.response?.data?.detail;
  return err?.response?.status === 402 && (
    data?.error === "chat_ad_required" ||
    data?.error === "chat_quota_exceeded"
  );
}
